import React from 'react';
import WelcomeMessageImage from './WelcomeMessageImage';
import './style.css';
import WelcomeMessageCloseButton from './WelcomeMessageCloseButton';

function WelcomeMessagePopup({
  hidden,
  message,
  dockLeft,
  greeterImageUrl,
  bottomOffset,
}) {
  if (hidden) return null;
  const [_hidden, setHidden] = React.useState(
    hidden || sessionStorage.getItem('userClosedGreeterImage')
  );

  const onClick = () => {
    sessionStorage.setItem('userClosedGreeterImage', true);
    setHidden(true);

    window.parent.postMessage(
      {
        type: 'USER_CLOSED_GREETER_MESSAGE',
      },
      '*'
    );
  };

  if (_hidden) return null;

  return (
    <div>
      <div
        className={
          dockLeft
            ? 'welcome-message-container widget-min-dock-left welcome-message-container-left'
            : 'welcome-message-container welcome-message-container-right'
        }
        style={{
          left: 'var(--ik-widget-left)',
          right: 'var(--ik-widget-right)',
          bottom: bottomOffset,
        }}
      >
        <div className="welcome-message-overlay" />
        <WelcomeMessageImage imageUrl={greeterImageUrl} />
        <span style={{ marginRight: 'auto' }}>{message}</span>
        <WelcomeMessageCloseButton onClick={onClick} />
      </div>
    </div>
  );
}

export default WelcomeMessagePopup;
